import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PatientChartComponent} from './patient-chart.component';

const routes: Routes = [
  {
    path: 'patientchart', component: PatientChartComponent,
    children: [
      {
        path: 'patient-chart-parent/:source/:visit_id',
        loadChildren: './patient-chart-parent/patient-chart-parent.module#PatientChartParentModule'
      }
    ]
  }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/patient-chart/patient-chart.routing.ts